/* ============================================================
   HALITE theme — interactions & effects
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var win = window;
  var reduceMotion = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = ('ontouchstart' in win) || (win.matchMedia && win.matchMedia('(pointer: coarse)').matches);

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var HALITE = win.HALITE || {};

  /* ---------------- money ---------------- */
  function formatMoney(cents) {
    var fmt = HALITE.moneyFormat || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    return fmt.split('{{amount}}').join(val);
  }

  /* ---------------- custom cursor ---------------- */
  function initCursor() {
    if (isTouch || reduceMotion || !HALITE.customCursor) return;
    doc.body.classList.add('cursor-on');
    var dot = $('#halite-cursor-dot');
    var ring = $('#halite-cursor-ring');
    if (!dot || !ring) return;
    var mx = -100, my = -100, rx = -100, ry = -100;

    win.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top = my + 'px';
    }, { passive: true });

    (function loop() {
      rx = lerp(rx, mx, 0.16);
      ry = lerp(ry, my, 0.16);
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(loop);
    })();

    var HOT = 'a, button, input, select, textarea, label, [data-hover], .card, .option-pill, summary, .filter-tag';
    doc.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(HOT)) ring.classList.add('ring-hot');
    });
    doc.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(HOT)) ring.classList.remove('ring-hot');
    });
  }

  /* ---------------- animated background system ---------------- */
  var BG = { mx: -1000, my: -1000 };

  function initGrid() {
    var canvas = $('#halite-grid');
    if (!canvas || !HALITE.gridFx) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(win.devicePixelRatio || 1, 2);
    var W, H;

    function resize() {
      W = win.innerWidth; H = win.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function draw(t) {
      if (reduceMotion) t = 0;
      var line = '255,184,77';
      ctx.clearRect(0, 0, W, H);

      // breathing horizon (drifts up/down) + drifting vanishing point (drifts left/right) + alpha pulse
      var horizon = H * 0.68 + Math.sin(t * 0.00021) * H * 0.016;
      var cx = W * 0.5 + Math.sin(t * 0.00013) * W * 0.07;
      var pulse = 1 + Math.sin(t * 0.0004) * 0.28;

      // horizontal lines (perspective spacing)
      var base = 26, growth = 1.16, y = horizon, i = 0;
      while (y < H + 40) {
        var tt = (y - horizon) / (H - horizon);
        var alpha = (0.035 + tt * 0.05) * pulse;
        ctx.strokeStyle = 'rgba(' + line + ',' + alpha.toFixed(3) + ')';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(W, y);
        ctx.stroke();
        i++;
        y = horizon + base * (Math.pow(growth, i) - 1);
      }

      // vertical rays sweeping slowly left/right
      var spread = 0.62, rays = 24;
      var sweep = Math.sin(t * 0.00011) * 0.035;
      for (var r = -rays / 2; r <= rays / 2; r++) {
        var angle = (r / rays) * Math.PI * spread + sweep;
        var dirX = Math.sin(angle), dirY = Math.cos(angle);
        var dist = H * 1.4;
        var x1 = cx + dirX * dist * 0.02;
        var y1 = horizon + dirY * dist * 0.02;
        var x2 = cx + dirX * dist;
        var y2 = horizon + dirY * dist * 1.05;
        var grad = ctx.createLinearGradient(x1, y1, x2, y1 + (y2 - y1) * 0.2);
        grad.addColorStop(0, 'rgba(' + line + ',0)');
        grad.addColorStop(1, 'rgba(' + line + ',' + (0.05 * pulse).toFixed(3) + ')');
        ctx.strokeStyle = grad;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
      }

      // cursor glow — the grid lights up around the mouse
      var mx = BG.mx, my = BG.my;
      if (mx > -500) {
        var g = ctx.createRadialGradient(mx, my, 0, mx, my, 200);
        g.addColorStop(0, 'rgba(' + line + ',0.18)');
        g.addColorStop(0.5, 'rgba(' + line + ',0.05)');
        g.addColorStop(1, 'rgba(' + line + ',0)');
        ctx.fillStyle = g;
        ctx.fillRect(mx - 210, my - 210, 420, 420);
      }
    }

    win.addEventListener('resize', resize);
    resize();
    BG.grid = draw;
  }

  /* glowing salt-crystal shards drifting freely in every direction */
  function initParticles() {
    var canvas = $('#halite-particles');
    if (!canvas || reduceMotion || isTouch) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(win.devicePixelRatio || 1, 2);
    var W = 0, H = 0;
    var parts = [];
    var lastScrollY = win.scrollY;

    function makeParticle(anywhere) {
      return {
        x: Math.random() * W,
        y: anywhere ? Math.random() * H : (Math.random() > 0.5 ? -24 : H + 24),
        vx: (Math.random() - 0.5) * 0.38,
        vy: (Math.random() - 0.5) * 0.38,
        size: 1.4 + Math.random() * 3.8,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.012,
        phase: Math.random() * Math.PI * 2,
        tw: 0.0008 + Math.random() * 0.0016,
        warm: Math.random() > 0.75
      };
    }

    function resize() {
      W = win.innerWidth; H = win.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (!parts.length) {
        var count = Math.min(44, Math.floor(W / 26));
        for (var i = 0; i < count; i++) parts.push(makeParticle(true));
      }
    }

    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      var dy = win.scrollY - lastScrollY; // parallax: page scroll nudges the shards
      lastScrollY = win.scrollY;

      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.x += p.vx; p.y += p.vy - dy * 0.045;
        p.rot += p.vr;

        // gentle repulsion from the cursor
        var mdx = p.x - BG.mx, mdy = p.y - BG.my;
        var md = Math.sqrt(mdx * mdx + mdy * mdy);
        if (md < 140 && md > 0.01) {
          var f = (140 - md) * 0.02;
          p.x += (mdx / md) * f;
          p.y += (mdy / md) * f;
        }

        // free movement — wraps on all four edges
        if (p.x < -26) p.x = W + 26; else if (p.x > W + 26) p.x = -26;
        if (p.y < -26) p.y = H + 26; else if (p.y > H + 26) p.y = -26;

        var alpha = 0.3 + 0.5 * (0.5 + 0.5 * Math.sin(t * p.tw + p.phase));
        var c = p.warm ? 255 : 235;
        var s = p.size;

        // soft glow halo
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, s * 4.2);
        g.addColorStop(0, 'rgba(255,' + c + ',77,' + (0.11 * alpha).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(255,' + c + ',77,0)');
        ctx.fillStyle = g;
        ctx.fillRect(p.x - s * 4.5, p.y - s * 4.5, s * 9, s * 9);

        // crystal shard
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot + Math.PI / 4);
        ctx.fillStyle = 'rgba(255,' + c + ',77,' + alpha.toFixed(3) + ')';
        ctx.fillRect(-s / 2, -s / 2, s, s);
        ctx.restore();
      }
    }

    win.addEventListener('resize', resize);
    resize();
    BG.parts = draw;
  }

  /* one global loop keeps grid + shards alive forever */
  function initBackgroundLoop() {
    win.addEventListener('mousemove', function (e) {
      BG.mx = e.clientX; BG.my = e.clientY;
    }, { passive: true });

    function frame(now) {
      var t = reduceMotion ? 0 : now;
      if (BG.grid) BG.grid(t);
      if (BG.parts) BG.parts(t);
      if (reduceMotion) return;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------------- header state ---------------- */
  function initHeader() {
    var header = $('.header');
    if (!header) return;
    var lastY = win.scrollY;
    function onScroll() {
      var y = win.scrollY;
      header.classList.toggle('header--scrolled', y > 10);
      lastY = y;
    }
    onScroll();
    win.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- mobile menu ---------------- */
  function initMobileMenu() {
    var burger = $('.header__burger');
    var menu = $('.mobile-menu');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () {
      menu.classList.toggle('open');
      burger.setAttribute('aria-expanded', menu.classList.contains('open') ? 'true' : 'false');
    });
    $$('.mobile-menu__link, .mobile-menu__close', menu).forEach(function (el) {
      el.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  /* ---------------- reveal on scroll ---------------- */
  function initReveal() {
    if (reduceMotion) {
      $$('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var els = $$('[data-reveal]');
    if (!('IntersectionObserver' in win)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          if (el.dataset.delay) el.style.transitionDelay = el.dataset.delay + 'ms';
          el.classList.add('in');
          setTimeout(function () { el.style.transitionDelay = ''; }, 1200);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- hero scroll assembly ---------------- */
  function initHero() {
    var section = $('.hero__section');
    if (!section) return;
    var exploded = $('.hero__img--exploded', section);
    var assembled = $('.hero__img--assembled', section);
    var content = $('.hero__content', section);
    var labels = $$('.hero__label', section);
    var hud = $('.hero__hud', section);
    var reduced = reduceMotion;

    function onScroll() {
      var rect = section.getBoundingClientRect();
      var total = section.offsetHeight - win.innerHeight;
      var p = clamp((-rect.top) / total, 0, 1);
      if (reduced) p = 0;

      // exploded → assembled transition
      if (exploded) {
        var eo = clamp(1 - p * 1.8, 0, 1);
        exploded.style.opacity = eo;
        exploded.style.transform =
          'translateY(' + lerp(46, -120, eo) + 'px) scale(' + lerp(1.06, 1.16, eo) + ') rotate(' + lerp(-1.2, -3.5, eo) + 'deg)';
      }
      if (assembled) {
        var ao = clamp((p - 0.28) / 0.34, 0, 1);
        var bob = Math.sin(win.scrollY / 260) * 8;
        assembled.style.opacity = ao;
        assembled.style.transform = 'translateY(' + bob + 'px) scale(' + lerp(0.86, 1, ao) + ') rotate(' + lerp(1.6, 0, ao) + 'deg)';
      }
      if (content) {
        content.style.opacity = clamp(1 - (p - 0.78) / 0.22, 0, 1);
        content.style.transform = 'translateY(' + p * -40 + 'px)';
      }
      // sequential technical labels
      labels.forEach(function (label, i) {
        var on = p > 0.06 + i * 0.09 && p < 0.52;
        label.classList.toggle('on', on);
      });
      if (hud) {
        hud.innerHTML = p < 0.5
          ? '<b>MODE://</b> EXPLODED VIEW<br><b>ASSEMBLY</b> ' + Math.round(clamp(p / 0.5, 0, 1) * 100) + '%<br><span class="blink">■</span> REC'
          : '<b>MODE://</b> ASSEMBLED<br><b>STATUS</b> GLOWING<br><span class="blink">■</span> LIVE';
      }
    }
    onScroll();
    win.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- 3D tilt cards ---------------- */
  function initTilt() {
    if (isTouch || reduceMotion) return;
    var cards = $$('[data-tilt]');
    cards.forEach(function (card) {
      var max = parseFloat(card.dataset.tilt) || 8;
      card.addEventListener('pointerenter', function (e) {
        var rect = card.getBoundingClientRect();
        card.dataset.rx = rect; card.dataset.rectMidX = rect.width / 2; card.dataset.rectMidY = rect.height / 2;
      });
      card.addEventListener('pointermove', function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var rx = -(py - 0.5) * 2 * max;
        var ry = (px - 0.5) * 2 * max;
        card.style.transition = 'transform 0.08s linear';
        card.style.transform = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateZ(0)';
        card.style.setProperty('--gx', (px * 100) + '%');
        card.style.setProperty('--gy', (py * 100) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.transition = 'transform 0.7s ' + 'cubic-bezier(0.22,1,0.36,1)';
        card.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
      });
    });
  }

  /* ---------------- magnetic buttons ---------------- */
  function initMagnetic() {
    if (isTouch || reduceMotion) return;
    $$('[data-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var rect = el.getBoundingClientRect();
        var dx = (e.clientX - rect.left - rect.width / 2) * 0.22;
        var dy = (e.clientY - rect.top - rect.height / 2) * 0.22;
        el.style.transition = 'transform 0.15s ease-out';
        el.style.transform = 'translate(' + clamp(dx, -9, 9) + 'px,' + clamp(dy, -9, 9) + 'px)';
      });
      el.addEventListener('pointerleave', function () {
        el.style.transition = 'transform 0.5s cubic-bezier(0.22,1,0.36,1)';
        el.style.transform = 'translate(0,0)';
      });
    });
  }

  /* ---------------- cart: drawer + count ---------------- */
  function initCart() {
    var drawer = $('.cart-drawer');
    var overlay = $('.drawer-overlay');
    var countEl = $('.header__cart-count');
    var itemsWrap = $('.cart-drawer__items');
    var totalEl = $('.cart-drawer__total b');
    if (!drawer) return;

    var openers = $$('[data-open-cart]');
    function openDrawer() { drawer.classList.add('open'); overlay.classList.add('open'); doc.body.style.overflow = 'hidden'; }
    function closeDrawer() { drawer.classList.remove('open'); overlay.classList.remove('open'); doc.body.style.overflow = ''; }
    openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
    $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    overlay.addEventListener('click', closeDrawer);
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      countEl.classList.toggle('show', n > 0);
    }
    function bumpCount() {
      if (!countEl) return;
      countEl.classList.remove('bump');
      void countEl.offsetWidth;
      countEl.classList.add('bump');
    }

    function renderCart(cart) {
      setCount(cart.item_count);
      if (!itemsWrap || !totalEl) return;
      var empty = $('.cart-drawer__empty', drawer);
      if (!cart.items.length) {
        itemsWrap.innerHTML = '';
        if (empty) empty.style.display = '';
        if (totalEl) totalEl.textContent = formatMoney(0);
        return;
      }
      var html = cart.items.map(function (it) {
        var img = it.featured_image && it.featured_image.url
          ? '<img src="' + it.featured_image.url + '" alt="' + escapeHtml(it.title) + '" loading="lazy">'
          : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-item__variant">' + escapeHtml(it.variant_title) + '</div>' : '';
        return '<div class="cart-item" data-key="' + it.key + '">' +
          '<div class="cart-item__img">' + img + '</div>' +
          '<div>' +
            '<div class="cart-item__title">' + escapeHtml(it.title) + '</div>' +
            variant +
            '<div class="cart-item__price">' + formatMoney(it.final_line_price) + '</div>' +
            '<div class="cart-item__qty">' +
              '<button type="button" data-qty="-1" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-qty="1" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-remove aria-label="Remove">Remove</button>' +
        '</div>';
      }).join('');
      itemsWrap.innerHTML = html;
      if (empty) empty.style.display = 'none';
      totalEl.textContent = formatMoney(cart.total_price);
    }

    function refreshCart() {
      return fetch(HALITE.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    }

    function addToCart(id, quantity, thenGoCheckout) {
      var body = new URLSearchParams();
      body.append('id', id);
      body.append('quantity', quantity);
      return fetch(HALITE.cartAddUrl + '.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: body
      })
        .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
        .then(function () {
          return refreshCart().then(function () {
            bumpCount();
            if (thenGoCheckout) { win.location.href = '/checkout'; }
            else { openDrawer(); }
          });
        })
        .catch(function (err) { console.error(err); });
    }

    // quantity & remove inside drawer (delegation)
    itemsWrap.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-qty]');
      var removeBtn = e.target.closest('[data-remove]');
      if (!qtyBtn && !removeBtn) return;
      var item = e.target.closest('.cart-item');
      if (!item) return;
      var key = item.dataset.key;
      var change = new URLSearchParams();
      if (removeBtn) {
        change.append('id', key);
        change.append('quantity', 0);
      } else {
        var span = $('.cart-item__qty span', item);
        var q = parseInt(span.textContent, 10) + parseInt(qtyBtn.dataset.qty, 10);
        change.append('id', key);
        change.append('quantity', Math.max(0, q));
      }
      fetch(HALITE.cartChangeUrl + '.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: change
      })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    });

    // any form with data-cart-add (ATC / quick add)
    doc.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-add]');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var goCheckout = !!(e.submitter && e.submitter.hasAttribute('data-buy-now'));
      addToCart(id, qty, goCheckout);
    });

    refreshCart();
  }

  /* ---------------- product page ---------------- */
  function initProduct() {
    var jsonEl = $('#halite-product-json');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var priceEl = $('.product__price-main', form);
    var compareEl = $('.product__price .compare', form);
    var atcBtn = $('[data-atc]', form);
    var stickyTitle = $('.sticky-atc__title');
    var stickyPrice = $('.sticky-atc__price');
    var stickyBar = $('.sticky-atc');

    var selected = {};
    var optionsWrap = $('.product__options', form);
    data.variants.forEach(function (v) {
      v.options.forEach(function (opt, i) {
        if (selected[data.options[i].name] === undefined) selected[data.options[i].name] = opt;
      });
    });

    function currentVariant() {
      var match = null;
      data.variants.forEach(function (v) {
        var ok = true;
        v.options.forEach(function (opt, i) {
          if (opt !== selected[data.options[i].name]) ok = false;
        });
        if (ok) match = v;
      });
      return match;
    }

    function renderOptions() {
      if (!optionsWrap) return;
      if (data.variants.length === 1 && !data.variants[0].options.filter(function (o) { return o !== 'Default Title'; }).length) {
        optionsWrap.innerHTML = '';
        return;
      }
      optionsWrap.innerHTML = data.options.map(function (option, oi) {
        var values = [];
        data.variants.forEach(function (v) {
          var val = v.options[oi];
          if (values.indexOf(val) === -1) values.push(val);
        });
        return '<fieldset class="option-row" data-option="' + oi + '">' +
          '<legend>' + escapeHtml(option.name) + '</legend>' +
          '<div class="option-pills">' +
          values.map(function (val) {
            var active = selected[option.name] === val ? ' active' : '';
            return '<button type="button" class="option-pill' + active + '" data-value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</button>';
          }).join('') +
          '</div></fieldset>';
      }).join('');
    }

    function update() {
      var v = currentVariant();
      if (!v) return;
      idInput.value = v.id;
      var asString = formatMoney(v.price);
      priceEl.textContent = asString;
      if (stickyPrice) stickyPrice.textContent = asString;
      if (stickyTitle) stickyTitle.textContent = data.title;
      if (compareEl) compareEl.textContent = v.compare_at_price ? formatMoney(v.compare_at_price) : '';
      if (atcBtn) {
        atcBtn.textContent = !v.available ? HALITE.strings.soldOut : HALITE.strings.addToCart;
        atcBtn.disabled = !v.available;
      }
      // disable unavailable pills
      $$('.option-pill', form).forEach(function (pill) {
        var oi = parseInt(pill.closest('[data-option]').dataset.option, 10);
        var val = pill.dataset.value;
        var possible = data.variants.some(function (vv) {
          if (vv.options[oi] !== val) return false;
          for (var key in selected) {
            var idx = data.options.findIndex(function (o) { return o.name === key; });
            if (idx !== oi && vv.options[idx] !== selected[key]) return false;
          }
          return true;
        });
        pill.disabled = !possible;
      });
    }

    optionsWrap.addEventListener('click', function (e) {
      var pill = e.target.closest('.option-pill');
      if (!pill || pill.disabled) return;
      var legend = pill.closest('fieldset').querySelector('legend').textContent;
      selected[legend] = pill.dataset.value;
      $$('.option-pill', pill.closest('fieldset')).forEach(function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
      update();
    });

    // qty stepper
    var stepper = $('.qty-stepper', form);
    if (stepper) {
      stepper.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var input = $('input', stepper);
        var q = parseInt(input.value, 10) || 1;
        q += parseInt(btn.dataset.qty, 10);
        input.value = Math.max(1, q);
      });
    }

    // gallery
    var mainMedia = $('.product__main-media');
    var thumbs = $$('.product__thumb');
    var mainImg = $('.product__main-media img');
    thumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        th.classList.add('active');
        if (mainImg && th.dataset.src) mainImg.src = th.dataset.src;
      });
    });

    // sticky add-to-cart visibility
    var info = $('.product__info');
    if (stickyBar && info && 'IntersectionObserver' in win) {
      var io = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(info);
    }

    renderOptions();
    update();
  }

  /* ---------------- collection sort ---------------- */
  function initSort() {
    var sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(win.location.href);
      url.searchParams.set('sort_by', sel.value);
      win.location.href = url.toString();
    });
  }

  /* ---------------- parallax ---------------- */
  function initParallax() {
    if (reduceMotion) return;
    var els = $$('[data-parallax]');
    if (!els.length) return;
    var pending = false;
    function tick() {
      pending = false;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var delta = (r.top + r.height / 2) - win.innerHeight / 2;
        el.style.transform = 'translateY(' + (delta * -0.06).toFixed(1) + 'px)';
      });
    }
    win.addEventListener('scroll', function () {
      if (!pending) { pending = true; requestAnimationFrame(tick); }
    }, { passive: true });
    tick();
  }

  /* ---------------- spec terminal readout ---------------- */
  function initSpecTerminal() {
    var list = $('[data-spec-list]');
    var term = $('[data-spec-terminal]');
    if (!list || !term || !('IntersectionObserver' in win)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        term.classList.toggle('visible', entry.isIntersecting);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    io.observe(list);
  }

  /* ---------------- boot ---------------- */
  function boot() {
    var body = doc.body;
    HALITE.gridFx = body.dataset.grid === 'true';
    HALITE.customCursor = body.dataset.cursor === 'true';
    initCursor();
    initGrid();
    initParticles();
    initBackgroundLoop();
    initHeader();
    initMobileMenu();
    initReveal();
    initHero();
    initTilt();
    initMagnetic();
    initCart();
    initProduct();
    initSort();
    initParallax();
    initSpecTerminal();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();